export const ACTIONS_COMMISSION = {
  INIT_COMMISSION: 'INIT_COMMISSION',
};

export const initCommission = data => ({
  type: ACTIONS_COMMISSION.INIT_COMMISSION,
  data,
});
